'use client';

import { Overlay } from '@/components/raven/Overlay';
import { type FC, useEffect, useCallback } from 'react';
import { useLoginContext } from '@/context/LoginContext';
import { useRouter, usePathname } from 'next/navigation';
import { ACCOUNT_PATH, LOGIN_VARIANT } from '@/constants';
import { useOverlayContext } from '@/context/OverlayContext';

import { LoginComponent } from './LoginComponent';

interface LoginDrawerProps {
	onClose?: () => void;
}

export const LoginDrawer: FC<LoginDrawerProps> = ({ onClose }) => {
	const { redirectTo, rgisCookie } = useLoginContext();
	const { closeVariant, isOpen } = useOverlayContext();
	const isLoggedIn = Boolean(rgisCookie);
	const { push } = useRouter();
	const pathname = usePathname();

	useEffect(() => {
		if (isLoggedIn && isOpen(LOGIN_VARIANT)) {
			if (redirectTo) {
				push(redirectTo); // Redirect when logged in
			}
			closeVariant(LOGIN_VARIANT);
		}
	}, [closeVariant, isLoggedIn, isOpen, push, redirectTo]);

	const handleOnClose = useCallback(() => {
		if (onClose) {
			onClose();
		}
		closeVariant(LOGIN_VARIANT);
		if (!isLoggedIn && pathname === ACCOUNT_PATH) {
			push('/'); // Redirect to home if not logged in
		}
	}, [closeVariant, isLoggedIn, onClose, pathname, push]);

	if (rgisCookie) {
		return null;
	}

	return (
		<Overlay className="right" onClose={handleOnClose} variant={LOGIN_VARIANT}>
			<LoginComponent />
		</Overlay>
	);
};
